import moment from 'moment';

export function momentToFormat(lang: string, date: string, format: string) {
  moment.locale('en');
  const convertedDate = moment(date).format(format);
  moment.locale(lang);
  return convertedDate;
}
